export class CompanyAccess {
    id = -1;
    memberId = -1;
    manager = false;

    deserialize(data: any): CompanyAccess {
        this.id = data.id ?? -1;
        this.memberId = data.member_id ?? -1;
        this.manager = data.manager ?? false;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            member_id: this.memberId,
            manager: this.manager,
        };
    }
}
